<template>
  <div>
    <sidebar></sidebar>
    <div :style="{ 'margin-left': sidebarwidth }">
      <topbar></topbar>
      <div class="px-2">
        <!-- pagination logic info -->
        <div class="flex justify-between items-center">
          <p class="font-semibold text-[18px]">Product Information</p>
          <div class="py-2 flex justify-between gap-10">
            <div class="pagination">
              <button @click="prevPage" :disabled="currentPage === 1">
                Previous
              </button>
              <span>{{ currentPage }} / {{ totalPages }}</span>
              <button @click="nextPage" :disabled="currentPage === totalPages">
                Next
              </button>
            </div>
          </div>
        </div>
        <!-- end of pagination logic info -->
        <div class="pt-2 w-full">
          <div class="relative overflow-x-auto">
            <table class="w-full text-sm text-left rtl:text-right text-black">
              <thead class="text-xs text-white uppercase bg-black">
                <tr>
                  <th scope="col" class="py-3 px-3"></th>
                  <th scope="col" class="py-3 px-3">Unique ID</th>
                  <th scope="col" class="py-3 px-3">Description</th>
                  <th scope="col" class="py-3 px-3">Aqucistion Data</th>
                  <th scope="col" class="py-3 px-3">Assest Class</th>
                  <th scope="col" class="py-3 px-3">Location</th>
                  <th scope="col" class="py-3 px-3">Group Name</th>
                  <th scope="col" class="py-3 px-3">Useful Life</th>
                  <th scope="col" class="py-3 px-3">Cost Price</th>
                  <th scope="col" class="py-3 px-3">Remarks</th>
                  <th scope="col" class="py-3 px-3">Upload Date</th>
                  <th scope="col" class="py-3 px-3">Last Upload Date</th>
                  <th scope="col" class="py-3 px-3">Last Print Date</th>
                  <th scope="col" class="py-3 px-3">Printed</th>
                  <th scope="col" class="py-3 px-3">Action</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="data in displayed_data"
                  :key="data.id"
                  class="odd:bg-white even:bg-gray-50 border-b dark:border-gray-700"
                >
                  <td class="py-4 px-3">
                    <input
                      type="checkbox"
                      :value="data.unique_id"
                      v-model="selectedItems"
                      @change="showResetButton = selectedItems.length > 0"
                    />
                  </td>
                  <td class="py-4 px-3">{{ data.unique_id }}</td>
                  <td class="py-4 px-3">{{ data.description }}</td>
                  <td class="py-4 px-3">{{ data.aqucistioni_data }}</td>
                  <td class="py-4 px-3">{{ data.asset_class }}</td>
                  <td class="py-4 px-3">{{ data.location }}</td>
                  <td class="py-4 px-3">{{ data.group_name }}</td>
                  <td class="py-4 px-3">{{ data.useful_life }}</td>
                  <td class="py-4 px-3">{{ data.cost_price }}</td>
                  <td class="py-4 px-3">
                    {{
                      data.remarks == "nan" || data.remarks == Null
                        ? ""
                        : data.remarks
                    }}
                  </td>
                  <td class="py-4 px-3">{{ data.upload_date }}</td>
                  <td class="py-4 px-3">{{ data.last_upload_date }}</td>
                  <td class="py-4 px-3">{{ data.last_print_date }}</td>
                  <td class="py-4 px-3">
                    {{ data.printed ? "True" : "False" }}
                  </td>
                  <td class="py-4 px-3">
                    <div class="flex justify-center gap-5">
                      <button>Action</button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div v-if="showResetButton" class="mt-4 flex justify-end">
          <button
            @click="resetSelectedItems"
            class="bg-red-500 text-white py-2 px-4 rounded"
          >
            Reset Checkbox
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import sidebar from "@/components/sidebar/Sidebar.vue";
import {
  ref,
  onMounted,
  onBeforeMount,
  getCurrentInstance,
  computed,
} from "vue";
import api from "../../boot/axios.js";
import { sidebarwidth } from "@/store/index.js";
import topbar from "@/components/topbar/topbarView.vue";
export default {
  components: {
    sidebar,
    topbar,
  },
  setup() {
    const productlist = ref([]);
    const selectedItems = ref([]);
    const showResetButton = ref(false);
    //------**--------
    const perPage = ref(10);
    const currentPage = ref(1);
    const searchQuery = ref("");

    // calling api
    const getallapi = async () => {
      await api.get("api/v1/productlist/").then((res) => {
        productlist.value = res.data;
        console.log(productlist.value, "checking ites");
      });
    };

    // Custome Table component creatation with pagination and result per page option
    const filteredProducts = computed(() => {
      const searchRegex = new RegExp(searchQuery.value.trim(), "i"); // 'i' flag for case-insensitive
      return productlist.value.filter((data) => searchRegex.test(data.name));
    });

    const displayed_data = computed(() => {
      const startIndex = (currentPage.value - 1) * perPage.value;
      const endIndex = startIndex + perPage.value;
      return filteredProducts.value.slice(startIndex, endIndex);
    });

    const totalPages = computed(() =>
      Math.ceil(productlist.value.length / perPage.value)
    );

    const changePerPage = () => {
      currentPage.value = 1; // Reset to the first page when changing items per page
    };

    const prevPage = () => {
      if (currentPage.value > 1) {
        currentPage.value--;
      }
    };

    const nextPage = () => {
      if (currentPage.value < totalPages.value) {
        currentPage.value++;
      }
    };
    const toggleSelectAll = () => {
      const allSelected =
        selectedItems.value.length === displayed_data.value.length;
      selectedItems.value = allSelected
        ? []
        : displayed_data.value.map((item) => item.unique_id);
    };
    const resetSelectedItems = () => {
      selectedItems.value = [];
      showResetButton.value = false;
    };

    onMounted(() => {
      getallapi();
    });

    return {
      productlist,
      filteredProducts,
      displayed_data,
      selectedItems,
      changePerPage,
      prevPage,
      nextPage,
      perPage,
      currentPage,
      totalPages,
      searchQuery,
      sidebarwidth,
      toggleSelectAll,
      resetSelectedItems,
      showResetButton,
      getallapi,
    };
  },
};
</script>
